import { createBrowserRouter } from 'react-router-dom';
import Providers from '../providers.tsx';
import AuthProtectedRoute from './auth-protected-route.tsx';
import NotFoundPage from '../pages/not-found.tsx';
import HomePage from '../pages/home.tsx';
import SignInPage from '../pages/auth/sign-in.tsx';
import ForgotPasswordPage from '../pages/auth/forgot-password.tsx';
import ResetPasswordPage from '../pages/auth/reset-password.tsx';
import CoursesPage from '../pages/courses.tsx';
import LevelsPage from '../pages/levels.tsx';
import QuestionsPage from '../pages/questions.tsx';
import LeaderboardPage from '../pages/leaderboard.tsx';
import NotificationsPage from '../pages/notifications.tsx';
import TestPage from '../pages/test.tsx';
import TestTimeOutPage, { TIMEOUT_PAGE_PATH } from '../pages/test-time-out.tsx';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Providers />,
    children: [
      {
        path: '/',
        element: <HomePage />,
      },
      {
        path: '/sign-in',
        element: <SignInPage />,
      },
      {
        path: '/forgot-password',
        element: <ForgotPasswordPage />,
      },
      {
        path: '/reset-password',
        element: <ResetPasswordPage />,
      },
      {
        path: '/',
        element: <AuthProtectedRoute />,
        children: [
          {
            path: '/courses',
            element: <CoursesPage />,
          },
          {
            path: '/courses/:courseId',
            element: <LevelsPage />,
          },
          {
            path: '/courses/:courseId/levels/:levelId',
            element: <QuestionsPage />,
          },
          {
            path: '/leaderboard',
            element: <LeaderboardPage />,
          },
          {
            path: '/notifications',
            element: <NotificationsPage />,
          },
          {
            path: '/test',
            element: <TestPage />,
          },
          {
            path: TIMEOUT_PAGE_PATH,
            element: <TestTimeOutPage />,
          },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
]);

export default router;
